import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero */}
      <section className="pt-40 pb-16 bg-[#0A2540]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white/60 text-xs uppercase tracking-widest mb-6">
            Légal
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Politique de confidentialité</h1>
          <p className="text-white/50 text-sm">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white flex-1">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="flex flex-col gap-10 text-gray-600 text-base leading-relaxed">

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">1. Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données personnelles collectées sur ce site est :
              </p>
              <ul className="mt-4 flex flex-col gap-2 text-sm">
                <li><strong>BOBROWSKA</strong> — Ewa Bobrowska</li>
                <li>49 Rue, 67130 Wisches, France</li>
                <li>Email : ewabobroowska@outlook.com</li>
              </ul>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">2. Données collectées</h2>
              <p>Dans le cadre de l&apos;utilisation du formulaire de contact, le site peut collecter les données suivantes :</p>
              <ul className="mt-4 flex flex-col gap-2 text-sm list-disc list-inside">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Message / description de la demande</li>
              </ul>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">3. Finalité du traitement</h2>
              <p>
                Les données personnelles collectées sont utilisées uniquement pour répondre aux demandes de contact et d&apos;information formulées par les utilisateurs. Elles ne sont pas utilisées à des fins commerciales ou publicitaires.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">4. Conservation des données</h2>
              <p>
                Les données sont conservées pour la durée nécessaire au traitement de la demande, et au maximum pendant 3 ans à compter du dernier contact.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">5. Partage des données</h2>
              <p>
                Les données personnelles collectées ne sont ni vendues, ni louées, ni partagées avec des tiers. Elles restent strictement confidentielles et sont utilisées uniquement par BOBROWSKA dans le cadre du traitement de votre demande.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">6. Vos droits</h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :
              </p>
              <ul className="mt-4 flex flex-col gap-2 text-sm list-disc list-inside">
                <li>Droit d&apos;accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l&apos;effacement (droit à l&apos;oubli)</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit d&apos;opposition</li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:ewabobroowska@outlook.com" className="text-[#0A2540] underline">ewabobroowska@outlook.com</a>
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">7. Cookies</h2>
              <p>
                Ce site peut utiliser des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie publicitaire ou de traçage n&apos;est utilisé.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">8. Contact</h2>
              <p>
                Pour toute question relative à la présente politique de confidentialité, vous pouvez nous contacter à : <a href="mailto:ewabobroowska@outlook.com" className="text-[#0A2540] underline">ewabobroowska@outlook.com</a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
